const aaa = [
	{
		path: "zongcang",
		component: () => import("@/views/huotiguanli/zongcang.vue"),
		meta:{title:'指挥中心',keepAlive:true},
	},
	{
		path: "detail",
		component: () => import("@/views/huotiguanli/detail.vue"),
		meta:{title:'详情'},
	}
]
export default aaa;